import React from "react";
import logo from "./../../assets/images/logo.svg";

export default function Logo() {
  return (
    <>
      <img src={logo} className="logo" alt="" />
    </>
  );
}
